const base = {
    baseUrl: "/api",
    potential: "/Customer/potentialStore",
    channel: "/service/potentialStore",
    saveMsg:'/companyTrial/apply'
};

export default base;
